import React, { useState } from "react";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="pt-10 lg:pt-12 pb-16 lg:pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <p className="text-base font-semibold uppercase tracking-wide text-gold text-center sm:text-left">FAQ</p>
          <h2 className="font-serif text-4xl text-center sm:text-left font-semibold text-navy-dark">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="border border-gray-300 divide-y divide-gray-300">
          {[
            {
              "question": "Why is insurance important?",
              "answer": "Insurance is important because it helps protect you from financial losses due to unexpected events like accidents, natural disasters, or medical emergencies. It provides peace of mind and financial security."
            },
            {
              "question": "What are the different types of insurance?",
              "answer": "Common types of insurance include health insurance, life insurance, auto insurance, home insurance, and business insurance. Each type offers protection against specific risks."
            },
            {
              "question": "How does insurance work?",
              "answer": "When you purchase insurance, you pay a premium to the insurer. In return, the insurer agrees to compensate you for covered losses or damages, as outlined in your policy."
            },
            {
              "question": "How do I choose the right insurance policy?",
              "answer": "Choosing the right insurance policy depends on your individual needs, budget, and risks. It's important to compare policies, coverage, and premiums from different insurers."
            }
          ].map((faq, index) => (
            <div
              key={index}
              className={`transition-colors duration-200 ${
                activeIndex === index ? "bg-navy-light" : "bg-white"
              }`}
            >
              <button
                className="w-full flex justify-between items-center p-5 text-lg font-normal leading-8 text-gray-900 hover:text-navy focus:outline-none"
                onClick={() => toggleAccordion(index)}
              >
                <h5>{faq.question}</h5>
                <svg
                  className={`w-6 h-6 transition-transform duration-300 ${
                    activeIndex === index ? "rotate-180" : ""
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.6}
                    d="M6 9l6 6 6-6"
                  />
                </svg>
              </button>

              <div
                className={`overflow-hidden transition-max-height duration-300`}
                style={{
                  maxHeight: activeIndex === index ? "200px" : "0",
                }}
              >
                <div className="p-4 text-gray-900 text-base font-normal leading-6">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call-to-Action Button */}
        <div className="mt-12 text-center">
          <a
            href="mailto:info@mcleaninsurancebrokers.com"
            className="inline-block text-white bg-navy hover:bg-navy-dark text-sm font-semibold uppercase tracking-wider px-6 py-3 focus:outline-none"
          >
            Questions? Email Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Faq;
